import { render, staticRenderFns } from "./postalInput.vue?vue&type=template&id=4d9bafee&scoped=true&"
import script from "./postalInput.vue?vue&type=script&lang=js&"
export * from "./postalInput.vue?vue&type=script&lang=js&"
import style0 from "./postalInput.vue?vue&type=style&index=0&id=4d9bafee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9bafee",
  null
  
)

export default component.exports